import {Component, OnInit, OnDestroy} from '@angular/core';
import {DocumentService} from '../../services/document.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Alert} from '../../../../shared/utilities';
import { Browser } from '@capacitor/browser';
import { GlobalQuestionService } from '../../../services/global-question.service';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


declare var $: any;

declare function initDocsNav(): any;

@Component({
  selector: 'app-doc-document',
  templateUrl: './doc-document.component.html',
  styleUrls: ['./doc-document.component.scss'],
  standalone: false
})
export class DocDocumentComponent implements OnInit, OnDestroy {

  printDoc = false;
  pdfDoc = false;
  isHeadless = false;
  document: any;
  sections: any;
  policy: any;
  user: any;
  overview: any;
  emailControl: any[] = [{ "placeholder": "Your friends email address" }];
  emailAddresses: any[] = [];
  footer: any;
  session_id: string;
  referrer_id = '2';
  documentPageRoute: any;
  product_name: string;
  device: any;
  previewFileUrl: SafeResourceUrl | null = null;
  private previewObjectUrl: string | null = null;
  private processingAlert: any;
  // set by preparePDF()/emailDoc() and run once the (pdfDoc) @if block's print stylesheet loads
  private onPrintCssReady: (() => void) | null = null;
  // relative (no leading slash) so it resolves against <base href> at runtime;
  // bound via [href] since a static href="..." on a stylesheet <link> is
  // treated by Angular's AOT compiler as a build-time resource path.
  printPdfCssHref: SafeResourceUrl;
  constructor(private documentService: DocumentService,
    public questionService: GlobalQuestionService,
    private policyQuery: PolicyQuery,
    private userStore: UserStore,
    private route: ActivatedRoute,
    public router: Router,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer) {
    this.printPdfCssHref = this.sanitizer.bypassSecurityTrustResourceUrl('assets/css/print_pdf.css');
    try{
      this.device = JSON.parse(localStorage.getItem('device'));
    }
    catch{}
    const navState = this.router.getCurrentNavigation()?.extras?.state;
    if (navState) {
      this.printDoc = navState?.print;
      this.pdfDoc = navState?.pdf;
      this.document = navState?.doc;
      this.session_id = navState?.session_id;
      this.referrer_id = navState?.referrer_id ?? '2';
      this.product_name = navState?.product?.product_name;
    } else if (this.route.snapshot.queryParamMap.get('document_id')) {
      // Opened in its own tab (e.g. window.open) instead of an in-app SPA navigation,
      // so there's no router state to read - fall back to query params instead.
      this.printDoc = this.route.snapshot.queryParamMap.get('print') === 'true';
      this.pdfDoc = this.route.snapshot.queryParamMap.get('pdf') === 'true';
      this.document = {
        document_id: this.route.snapshot.queryParamMap.get('document_id'),
        document_name: this.route.snapshot.queryParamMap.get('document_name')
      };
      this.session_id = this.route.snapshot.queryParamMap.get('session_id');
      this.referrer_id = this.route.snapshot.queryParamMap.get('referrer_id') ?? '2';
      this.product_name = this.route.snapshot.queryParamMap.get('product_name');
    } else {
      this.router.navigate(['/everything.policy-resources']);
    }
    this.isHeadless = this.route.snapshot.queryParamMap.get('headless') === 'true';
    // blank the screen from here through print/pdf prep, not just once preparePDF() runs
    if (this.pdfDoc || this.printDoc) {
      this.questionService.spinner(true);
    }
    this.policy = this.policyQuery.getActive();
    console.log(this.policy)
    if (this.policy) this.product_name = this.policy?.product_name;
    this.user = this.userStore.getValue();
    this.documentPageRoute = localStorage.getItem('previous-document-page');
  }

  ngOnInit(): void {
    if (!this.document) {
      const params = this.route.snapshot.queryParamMap;
      const documentId = params.get('document_id');
      if (documentId) {
        this.document = { document_id: documentId };
        this.session_id = params.get('session_id');
        this.isHeadless = params.get('headless') === 'true';
        this.pdfDoc = params.get('pdf') === 'true';
        this.printDoc = params.get('print') === 'true';
      } else {
        this.router.navigate(['/everything.policy-resources']);
        return;
      }
    }
    this.documentService.getIP().subscribe(ip => {
      this.getDocument(ip);
      }, error => {
        this.getDocument('0.0.0.0');
      });
  }
  getDocument(ip: string): void {
    const parameters = new Map<string, string>();
    if (!this.session_id && this.policy?.session_id) {
      this.session_id = this.policy?.session_id;
    }
    parameters.set('document_id', this.document.document_id.toString());
    parameters.set('ip_address', ip);
    parameters.set('session_id', this.session_id);
    parameters.set('referrer_id', this.referrer_id);
    parameters.set('encrypt', "0");
    this.questionService.runCommandNew(`getDocument`, parameters, true).subscribe(doc => {
      this.overview = doc[0][0];
      this.sections = doc[1];
      this.footer = doc[2][0];
      if (doc) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $('.page').offset().top
        }, 0);
        setTimeout(() => {
          this.initSearch($('#search-input'));
          this.initShareViaEmail();
          var sideMenuSidesheet = (function () {

            function init(args) {

              // close listeners...

              // on back button
              $(document).on('click', '.sidesheet__header-back', function () {
                closeSidesheet();
              });

              // on outside click
              $(document).on('click.outsidesidesheet', function (e) {
                var $target = $(e.target);
                if (!$target.closest("#sidesheet").length && !$target.closest(args.outsideClickElement).length) {
                  closeSidesheet();
                }
              });

            }

            function closeSidesheet() {
              $('#sidesheet').removeClass('is-active');
              $('body').removeClass('sidesheet-open');
            }
            function openSidesheet() {
              $('#sidesheet').addClass('is-active');
              $('body').addClass('sidesheet-open');
            }

            return {
              init: init,
              openSidesheet: openSidesheet,
              closeSidesheet: closeSidesheet
            }
          })();
          sideMenuSidesheet.init({ outsideClickElement: '.central-nav__burger' });
          $('.central-nav__burger').on('click', function () {
            sideMenuSidesheet.openSidesheet();
          });
          this.initDocsNav();
          if (this.printDoc) { window.print(); this.questionService.spinner(false); }
          if (this.pdfDoc) {
            this.preparePDF();
          }
        }, 1000);
      }
    })
  }
  initSearch($input): void {
    $.fn.highlight = function (pat, callback) {

      function innerHighlight(node, pat) {
        var skip = 0;
        if (node.nodeType == 3

          // exclusions:
          // text within dropdowns
          && !node.parentNode.closest('.dropdown-menu')
          && !node.parentNode.closest('.dropdown-item')
        ) {
          node.data = node.data.replace(/[\n\r]+/g, ''); // replace new lines
          node.data = node.data.replace(/\s{2,10}/g, ' '); // replace multiple spaces with just 1
          var pos = node.data.toUpperCase().indexOf(pat);
          pos -= (node.data.substr(0, pos).toUpperCase().length - node.data.substr(0, pos).length);
          if (pos >= 0) {
            var spannode = document.createElement('span');
            spannode.className = 'search-hilite';
            var middlebit = node.splitText(pos);
            var endbit = middlebit.splitText(pat.length);
            var middleclone = middlebit.cloneNode(true);
            spannode.appendChild(middleclone);
            middlebit.parentNode.replaceChild(spannode, middlebit);
            skip = 1;
            if (callback) callback();
          }
        }
        else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
          for (var i = 0; i < node.childNodes.length; ++i) {
            i += innerHighlight(node.childNodes[i], pat);
          }

        }

        return skip;
      }


      return this.length && pat && pat.length ? this.each(function () {
        innerHighlight(this, pat.toUpperCase());
      }) : this;

    };

    $.fn.removeHighlight = function () {
      return this.find("span.search-hilite").each(function () {
        const parent = this.parentNode;
        if (parent) {
          parent.replaceChild(this.firstChild as ChildNode, this);
          parent.normalize();
        }
      }).end();
    };

    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop() + $('.navbar').outerHeight();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    var settings = {
      searchThreshold: 1
    }

    var $searchTrigger = $('#search-trigger, #search-trigger-mobile'),
      $searchContainer = $('#search-container'),
      $inputClear = $('#search-clear'),
      $content = $('#search-body');
    const $searchClose = $('#search-close')

    var result_count = 0,
      curr_result;


    $searchTrigger.off('click').on('click', function (e) {
      e.stopPropagation();

      $searchTrigger.removeClass('is-active');
      $searchContainer.addClass('is-active').closest('.navbar-sub').addClass('search-active');
      $input.focus();

      // listen for outside clicks and close
      $(document).on('click.outsidesearch', function (e) {
        var $target = $(e.target);
        if (!$target.closest(".navbar-sub__search").length && $input.val() == '') {
          resetSearch();
        }
      });

    });

    $inputClear.on('click', function (e) {
      e.preventDefault();
      resetResults();
    });


    $input.on('keyup', function () {

      var search_string = $input.val();
      resetResults();

      // if search bar contains more than x letters
      if (search_string.length > settings.searchThreshold) {

        $content.highlight(search_string, function () {
          result_count++;
        });

        console.log('result count: ' + result_count);

        if (result_count) {
          scrollToResult(1);
        }

      }


    });


    $('.navbar-sub__search-down').on('click', function (e) {
      e.preventDefault();
      goToNextResult();
    });

    $('.navbar-sub__search-up').on('click', function (e) {
      e.preventDefault();
      goToPrevResult();
    });


    $searchClose.on('click', function (e) {
      e.preventDefault();
      resetSearch();
    });


    function goToNextResult() {
      if (curr_result < result_count) {
        scrollToResult(curr_result + 1);
      } else {
        curr_result = 0;
        goToNextResult();
      }
    }

    function goToPrevResult() {
      if (curr_result > 1) {
        scrollToResult(curr_result - 1);
      } else {
        curr_result = result_count + 1;
        goToPrevResult();
      }
    }



    function scrollToResult(resultNo) {

      curr_result = resultNo;

      var $targetEl = $content.find('.search-hilite').eq(resultNo - 1);

      $content.find('.search-hilite').removeClass('is-active');
      $targetEl.addClass('is-active');

      if ($targetEl.isInViewport()) {
        // don't scroll page

        // if not in viewport
      } else {

        if ($targetEl.is(":visible")) {

          let offset = window.matchMedia('(min-width: 992px)').matches ? 50 : $('.layout__sidecol').outerHeight();

          // scroll to target
          $('html, body').scrollTop(
            $targetEl.offset().top - $('.navbar').outerHeight() - offset
          );
        }

      }

    }


    function showNoResults() {
      console.log('no results');
      //$noResults.addClass('is-active');
    }


    function resetResults() {
      result_count = 0;
      $content.removeHighlight();
    }

    function resetSearch() {
      $(document).off('click.outsidesearch');
      $input.val('');
      resetResults();
      $searchTrigger.addClass('is-active');
      $searchContainer.removeClass('is-active').closest('.navbar-sub').removeClass('search-active');
    }

  }
  initDocsNav(): void {
    var scrollSpy =  (function() {

      var scrollPos;
      var offset;
      var navTargets = [];
  
      function init(nav) {
  
         // offset includes height of fixed nav area
         offset = window.matchMedia('(min-width: 992px)').matches ? $('.breadcrumbs').outerHeight() : $('.layout__sidecol').outerHeight();
  
         // and add 100px as a threshold
         offset += 100;
  
         // store target positions
         $(nav).first().find('li').each(function () {
            var target = $(this).find('a').attr('href');
            if (target === '#') return;
            if ($(target).length) {
  
               let targetPos = Math.floor($(target).offset().top - $('.navbar').outerHeight() - offset - 1)
               if (targetPos < 0) targetPos = 0;
  
               navTargets.push([target, targetPos]);
            }
         });
  
         spy(nav);
      }
  
      function spy(nav) {
         scrollPos = $(window).scrollTop();          
  
         // check each target against scroll position
         navTargets.forEach(function (id, idx) {
  
            // if scroll below target
            if (scrollPos > navTargets[idx][1]) {
  
               // if there is a next target
               if ((idx + 1) < navTargets.length) {
  
                  // check that scroll pos less than next target
                  if (scrollPos < navTargets[idx + 1][1]) {
                     activate(nav, id[0]);
                  }
  
                  // else no further targets, can activate
               } else {
                  activate(nav, id[0]);
               }
  
               // else if target is first item
            } else if (idx == 0) {
               activate(nav, id[0]);
            }
  
         })
      }
  
      function activate(nav, id) {
  
         let $activeLi = $(nav).find('li a[href="' + id + '"]').closest('li');
  
         // activate current li and remove siblings
         $activeLi.addClass('is-spied')
            .siblings('li').removeClass('is-spied')
            .find('li').removeClass('is-spied');
  
         // activate parents if exist and deactivate siblings and children
         let $activeParentLi = $activeLi.closest('ul').closest('li');
         $activeParentLi
            .addClass('is-spied')
            .siblings('li').removeClass('is-spied')
            .find('li').removeClass('is-spied');
      }
      return {
         init: init,
         spy: spy
      };
   })();
    scrollSpy.init('#docs-nav, #docs-nav-mobile');
    $(window).on('scroll.spy', function () { scrollSpy.spy('#docs-nav, #docs-nav-mobile'); });
    $(window).on('resize.spy', function () { scrollSpy.init('#docs-nav, #docs-nav-mobile'); });

    // activate/deactive nav
    $('.central-nav__list li.has-sub > a').on('click', function (e) {
       e.preventDefault();
       $(this).parent('li').toggleClass('is-active')
          .siblings('li').removeClass('is-active');
    });

 }
  getSections(): any[] {
    const sections = [];
    this.sections?.forEach(s => {
      if (!sections?.some(x => x?.section_name.toLowerCase() === s?.section_name.toLowerCase()) && s?.section_name !=='Header' ) {
        sections.push(s);
      }
    });
    return sections;
  }
  getSectionChildren(section: string): any {
    return this.sections.filter( c => c.section_name === section);
  }
  preparePDF(): void {
    this.questionService.spinner(true);
    this.pdfDoc = true;
    document.querySelector('body')?.classList.add('page--pdf');
    document.querySelector('body')?.classList.remove('page--pdf-view');
    document.querySelector('body')?.classList.remove('page--central');
    if (this.isHeadless) {
      // pdf-service drives this page directly via Chromium print-to-PDF, so skip the
      // legacy vader print/email flow and just signal once layout is ready to capture.
      this.onPrintCssReady = () => {
        this.questionService.initPDFStuff();
        setTimeout(() => { document.body.dataset['pdfReady'] = 'true'; }, 2000);
        this.questionService.spinner(false);
      };
      return;
    }
    this.processingAlert = Alert("Processing... please wait", 10000);
    this.onPrintCssReady = () => {
      this.questionService.initPDFStuff();
      // 30s is just a fallback cap; normally cleared as soon as the pdf renders (see onPdfIframeLoad)
      this.processingAlert = Alert("Processing... please wait", 30000);
      this.questionService.spinner(false);
      this.printPDF();
    };
  }
  // fires once the print stylesheet the (pdfDoc) @if block just created has actually
  // loaded — calling initPDFStuff() straight after the flag flip races the browser's
  // fetch/parse of that <link>, so heights get measured under the pre-print layout.
  onPrintCssLoaded(): void {
    this.onPrintCssReady?.();
    this.onPrintCssReady = null;
  }
  printPDF(): void {
    const element = document.getElementById('search-body');
    this.questionService.pdf(element.innerHTML,'',false,0,'','print_pdf_v1', 'bundle_v1').subscribe(resp => {
      let id = resp.replace('https://vader.everything.insure/pdf/files/','');
      const isNative = this.device?.platform && this.device.platform !== 'web';
      if (isNative) {
        Browser.open({ url: resp.toString() });
        this.clearProcessingAlert();
      } else {
        this.openPDFPreview(resp.toString());
      }
      setTimeout(() => {
        this.questionService.pdf('',id).subscribe()
      }, 5000);
    })
  }
  openPDFPreview(url: string): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
      this.previewObjectUrl = null;
    }
    this.httpClient.get(url, { responseType: 'blob' }).subscribe(blob => {
      this.previewObjectUrl = URL.createObjectURL(blob);
      this.previewFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
      $('#modal-pdf-preview').modal('show');
    });
  }
  onPdfIframeLoad(): void {
    this.clearProcessingAlert();
  }
  clearProcessingAlert(): void {
    this.processingAlert?.clear?.();
    this.processingAlert = null;
  }
  push(): void {
    this.emailControl.push({ "placeholder": "Your friends email address" });
  }
  pop(): void {
    this.emailControl.pop();
  }
  checkEmail(): void {
    $('.emails').each((i, e) => {
      this.emailAddresses.push(e.value);
   })
    console.log(this.emailAddresses)
  }
  emailDoc(): void{
    $('.emails').each((i, e) => {
      this.emailAddresses.push(e.value);
   })
    this.processingAlert = Alert("Processing... please wait", 10000);
    this.pdfDoc = true;
    document.querySelector('body')?.classList.add('page--pdf');
    document.querySelector('body')?.classList.remove('page--pdf-view');
    document.querySelector('body')?.classList.remove('page--central');
    this.onPrintCssReady = () => {
      this.questionService.initPDFStuff();
      const element = document.getElementById('search-body');
      this.questionService.pdf(element.innerHTML,'',true,this.policy.person[0].person_id,this.emailAddresses.toString(),'print_pdf_v1','bundle_v1').subscribe(resp => {
        Alert("Document sent.");
      })
    };
  }
  includesString(html: string,text: string): boolean {
    let includes = false;
    let arr = text.split(',')
     arr.forEach(s => {
        if ( html?.includes(s)) includes = true;
     });
    return includes;
  }
  initShareViaEmail(): void {

    // demo activate send invites button (same as on 'yay, covered')
    $(document).on("change", "#share-email-modal input", function (e) {
      // disable send button
      $("#send-invites-btn").attr("disabled", true);

      var inputsValid = true;
      var inputsEmpty = true;

      // check all inputs
      $("#share-email-modal input").each(function () {
        var $input = $(this);
        var $formGroup = $input.closest(".form-group");

        // check is valid
        if (this.validity.valid) {
          $formGroup.removeClass("has-error").find(".form-control-error").remove();
        } else {
          $formGroup.addClass("has-error");

          // if error doesn't already exist and an error msg defined, show error
          if (!$formGroup.find(".form-control-error").length && $input.attr("data-msg-error") != null) {
            $formGroup.append('<label class="form-control-error">' + $input.attr("data-msg-error") + "</label>");
          }

          inputsValid = false;
        }

        // check not empty
        if ($(this).val() !== "") {
          inputsEmpty = false;
        }
      });

      // if valid and not empty
      if (inputsValid && !inputsEmpty) {
        $("#send-invites-btn").attr("disabled", false); // enabled
      } else {
        $("#send-invites-btn").attr("disabled", true); // disabled
      }
    });

    // demo send invites success msg
    $(document).on("click", "#send-invites-btn", function (e) {
      //  var invitesSuccess = new notify();
      //  invitesSuccess.init({
      //     message: "The <strong>Policy wording</strong> document has been shared.", // required
      //     icon: "complete", // default: null; options: 'info', 'complete', or any icon name in the sprite
      //     size: "lg", // default: null; options: 'lg'
      //     style: "info", // default: null; options: 'info', 'success',
      //     duration: 8000, // default: 5000 (duration active), also accepts 'indefinite',
      //     close: true,
      //  });
    });

  }
  ngOnDestroy(): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
    }
  }

}
